import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

// export const getProjectsList = (id, query, token) => {
//   let qs = buildQuery(query);
//   let url = `${baseUrl}/projects/user/${id}${qs}`;
//   return axios.get(url, {
//     headers: {
//       authorization: token,
//     },
//   });
// };

// export const getAllSiteCountbyProject = (token,query) => {
//   let qs = buildQuery(query);
//   let url = `${baseUrl}/getSiteCountbyProject${qs}`;
//   return axios.get(url, {
//     headers: {
//       authorization: token,
//     },
//   });
// };
// ;

export const getallSitesData = (token) => {
  return axios.get(`${baseUrl}/getSites`, {
    headers: {
      authorization: token,
    },
  });
};

export const getSitesMgmtbyProjectID = (token,id) => {
    //   let qs = buildQuery(query);
  return axios.get(`${baseUrl}/getSitesMgmtbyProjectID/${id}`, {
    headers: {
      authorization: token,
    },
  });
};
export const insertSiteData = (data, token) => {
  return axios.post(`${baseUrl}/insertSite`, data, {
    headers: {
      authorization: token,
    },
  });
}   


export const updateSiteById = (data,token,id) => {
  return axios.put(`${baseUrl}/updateSiteById/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
}
export const insertSiteContact = (token,data) => {
  return axios.post(`${baseUrl}/insertSiteContact`, data, {
    headers: {
      authorization: token,
    },
  });
}  
 
export const getSiteContactsbySiteID = (token,id) => {
  return axios.get(`${baseUrl}/getSiteContactsbySiteID?site_id=${id}`, {
    headers: {
      authorization: token,
    },
  });
}
 